import React, { useState } from 'react';
import { ICommandBarItemProps, PrimaryButton, Stack } from '@fluentui/react';
import { commandBarTheme, commandBarThemeCounter } from '../../../theme';
import { CommandBarSticky } from '../../../components/parts';
import { BillitInvoice } from '../types';
import BillitInvoiceDetailList from './BillitInvoiceDetailList';
import BillitInvoiceDetail from './BillitInvoiceDetail';

export interface BillitInvoiceOverviewProps {
  loading?: boolean;
  loadingMore?: boolean;
  invoices: BillitInvoice[];
  refetch: () => void;
  total: number;
  showLoadMore?: boolean;
  loadMoreCallback?: () => void;
  onReturnToToAssign?: () => void;
}

const BillitInvoiceOverview: React.FC<BillitInvoiceOverviewProps> = ({
  invoices,
  loading,
  loadingMore = false,
  refetch,
  total,
  showLoadMore = false,
  loadMoreCallback = () => {},
  onReturnToToAssign,
}) => {
  const [selectedInvoice, setSelectedInvoice] = useState<BillitInvoice>();
  const [isDetailPanelOpen, setIsDetailPanelOpen] = useState(false);

  const handleSelect = (invoice: BillitInvoice) => {
    setSelectedInvoice(invoice);
    setIsDetailPanelOpen(true);
  };

  const handleDismissPanel = (closeAll?: boolean) => {
    setIsDetailPanelOpen(false);
    if (closeAll === true) {
      setSelectedInvoice(undefined);
    }
  };

  const commandBaritems: ICommandBarItemProps[] = [
    {
      key: 'totaal',
      text: `${invoices.length}/${total}`,
      theme: commandBarThemeCounter,
    },
  ];

  return (
    <>
      <CommandBarSticky
        items={commandBaritems}
        theme={commandBarTheme}
        maxWidth='2000px'
      />

      <BillitInvoiceDetailList
        items={invoices}
        enableShimmer={loading}
        onSelect={handleSelect}
        loadMore={!!loadMoreCallback}
        loadMoreCallback={loadMoreCallback}
      />

      {showLoadMore && (
        <Stack
          style={{ marginTop: '15px', marginLeft: 'auto', marginRight: 'auto' }}
          horizontal
          horizontalAlign='center'
        >
          <PrimaryButton
            text='Toon meer'
            onClick={loadMoreCallback}
            disabled={loading || loadingMore}
          />
        </Stack>
      )}

      <BillitInvoiceDetail
        isOpen={isDetailPanelOpen}
        dismissPanel={handleDismissPanel}
        invoice={selectedInvoice}
        refetch={refetch}
        onFastActionComplete={() => {
          onReturnToToAssign?.();
          handleDismissPanel(true);
        }}
      />
    </>
  );
};

export default BillitInvoiceOverview;
